const HeaderAlertsTitle = ({ count }: { count: number }) => {
  const prepareHeaderAlertsTitle = (totalCount: number): JSX.Element => {
    if (totalCount > 5) {
      return (
        <>
          Last <b>5</b> Out of <b>{totalCount}</b> Unresolved Alerts
        </>
      );
    } else if (totalCount > 0 && totalCount <= 5) {
      return (
        <>
          <b>{totalCount}</b> Unresolved Alerts
        </>
      );
    }
    return <>No Unresolved Alerts</>;
  };

  const title = prepareHeaderAlertsTitle(count);

  return (
    <div
      className="header-alerts__list-item header-alerts__list-item--title"
      data-testid="header_alerts_title"
    >
      {title}
    </div>
  );
};

export default HeaderAlertsTitle;
